import { throwApiError } from "../components/lms-shared/store/error-handling-actions";
import { lessonsApi, notCachefetchJson, sendMessageToServiceWorker } from "../utils";
import { generalAction } from "./general-slice";

export const changeActiveLessonId = (lessonId, studyGroupId, lessonName, groupUsers) => {

  return async (dispatch, getState) => {
    // try {
    const state = getState();

    if (state.auth.user.isStudent && state.general.activeLessons[studyGroupId] !== lessonId) {
      const lessonUserActiveLessonChangeInput = {
        lessonId: lessonId,
        studyGroupId: studyGroupId,
        lessonName: lessonName,
        users: groupUsers
      }
      lessonsApi.lessonsUserActiveLessonChangePost({ lessonUserActiveLessonChangeInput: lessonUserActiveLessonChangeInput }, async (error, resdata, response) => {
        if (error) {
          dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "lessonsUserActiveLessonChangeGet " + error.message, level: 1, component: "general-actions", line: 14 }))
        }
        else {

          if ('serviceWorker' in navigator) {
            sendMessageToServiceWorker('lessonUserActiveChangeSuccess', { lessonId, studyGroupId });
          }

          dispatch(generalAction.change({
            lessonId: lessonId,
            studyGroupId: studyGroupId
          }))
        }
      })
    }
    // }
    // catch (e) {
    //   console.error(e);
    // }
  }
}

export const getGeneral = () => {
  return async (dispatch) => {
      try {
          let res = await notCachefetchJson(window.config.uiData)
          if (res) {
              dispatch(generalAction?.initUiData(res));
          }
      }
      catch (e) {
      }
  }
}